module.exports = __webpack_public_path__ + "static/media/back-1.e0e3c1d6.png";